import { useEffect } from 'react';

import { EventName, PaymentStatusView } from 'enums';
import { eventUtils } from 'utils';

import { useOrderContext } from './use-order-context.hook';

const FLOW_EVENT_BY_STATUS: Partial<Record<PaymentStatusView, EventName>> = {
  [PaymentStatusView.Success]: EventName.PaymentFlowComplete,
  [PaymentStatusView.Cancel]: EventName.PaymentFlowCanceled,
  [PaymentStatusView.Dispute]: EventName.PaymentFlowDispute,
};

// Fires once on mount — paymentStatusView is fixed when the status screen renders
export const useTrackFlowEvent = () => {
  const { order, paymentStatusView } = useOrderContext();

  useEffect(() => {
    const flowEvent = FLOW_EVENT_BY_STATUS[paymentStatusView];
    if (!flowEvent) {
      return;
    }
    const timeoutId = setTimeout(() => {
      eventUtils.trackEvent({
        event: flowEvent,
        message: order?.statusDetails || undefined,
      });
      if (flowEvent === EventName.PaymentFlowComplete) {
        eventUtils.stopEvents();
      }
    }, 0);
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
